<template>
    <l-control position="topleft">
        <div @focusin="visible=true" @focusout="visible=false" class="d-flex flex-column align-items-center rounded bg-dark">
            <b-button variant="dark" :disabled="visible" href="#" tabindex="0">
                <img src="../assets/interface/settings.svg" 
                    :class="imgClass" 
                    style="height:1.5em;filter:invert(90%);transition:transform .5s" 
                />
            </b-button>
            <b-collapse v-model="visible" @show="imgClass = 'mx-n1 rotate'" @hide="imgClass = 'mx-n1'">
                <slot/>
            </b-collapse>
            </div>
    </l-control>
</template>

<script>
import { LControl } from 'vue2-leaflet'
import { BCollapse } from "bootstrap-vue"

export default {
    name: "UebersichtControlBar",
    components: {
        LControl,
        BCollapse
    },
    data(){
        return{
            visible: false,
            imgClass: "mx-n1"
        }
    },
    methods:{
        logge(x){
            console.log(x)
        },
        focusout(){
            setTimeout(() => this.visible=false, 500)
        }
    }
}
</script>

<style scoped>
.rotate{
    transform: rotate(135deg);
    transition: transform .5s
}
</style>